import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '@/i18n';
import { useSettings, type ThemeSetting } from '@/features/settings/settingsStore';
import { SunIcon } from './parts';

const THEME_ORDER: readonly ThemeSetting[] = ['system', 'dark', 'light'];

/** Language segmented switch and theme cycle button (top bar on Home and Setup). */
export function HeaderTools() {
  const { t } = useTranslation();
  const language = useSettings((s) => s.language);
  const theme = useSettings((s) => s.theme);
  const set = useSettings((s) => s.set);

  const nextTheme = THEME_ORDER[(THEME_ORDER.indexOf(theme) + 1) % THEME_ORDER.length] ?? 'system';
  const themeName = t(`settings.themes.${theme}`);

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <div
        role="group"
        aria-label={t('settings.language')}
        className="inline-flex rounded-full border border-line bg-surface-2 p-[3px]"
      >
        {LANGUAGES.map((l) => (
          <button
            key={l.code}
            type="button"
            lang={l.code}
            aria-pressed={language === l.code}
            onClick={() => set({ language: l.code })}
            className={`min-h-[50px] rounded-full px-3 text-sm font-semibold ${
              language === l.code ? 'bg-fg text-bg' : 'text-muted'
            }`}
          >
            {t(`settings.languagesShort.${l.code}`)}
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={() => set({ theme: nextTheme })}
        aria-label={`${t('settings.theme')}: ${themeName}`}
        className="inline-flex min-h-touch items-center gap-1.5 rounded-full border border-line bg-surface-2 px-3 text-sm font-semibold"
      >
        <SunIcon />
        <span className="max-[420px]:sr-only">{themeName}</span>
      </button>
    </div>
  );
}
